import axios from 'axios';
import {CONFIG, URLS} from '../helpers/Common';


export const USER = {
    login,
    signup,
    forgotPassword,
    getProfile,
    editProfile
};

function login(usersData)
{
    let requestOptions = {
        method:'GET',
        url:`${CONFIG.API_URL+URLS.users}?email=${usersData.email}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function signup()
{

}

function forgotPassword()
{

}

function getProfile()
{

}

function editProfile()
{
    
}